export default __webpack_public_path__ + "static/mens-health-b7495dc302c7922aa2b4779afcd7b68e.jpg";